var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.817 57.3115C39.817 57.3115 33.7678 44.6059 25.477 43.2487",
    stroke: "#311806",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8164 28.6883C39.8164 28.6883 31.3474 43.0823 25.5322 43.1387",
    stroke: "#311806",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5236 43.1357L25.588 43.1357",
    stroke: "#311806",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43 84.6998C66.0303 84.6998 84.7 66.0301 84.7 42.9998C84.7 19.9695 66.0303 1.2998 43 1.2998C19.9697 1.2998 1.29999 19.9695 1.29999 42.9998C1.29999 66.0301 19.9697 84.6998 43 84.6998Z",
    stroke: "#311806"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.e3ff070c0bb68634940bfb555a3c2341.svg";
export { ForwardRef as ReactComponent };